import { motion } from 'framer-motion'
import { Home, Search } from 'lucide-react'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-50 dark:bg-surface-950 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <div className="mb-8">
          <h1 className="font-poppins font-bold text-9xl text-mavi-600 dark:text-mavi-400">
            404
          </h1>
          <h2 className="font-poppins font-semibold text-2xl text-gray-900 dark:text-white mb-4">
            Sayfa Bulunamadı
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            Aradığınız sayfa mevcut değil veya taşınmış olabilir.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="btn-primary flex items-center justify-center gap-2 w-full"
          >
            <Home className="w-5 h-5" />
            Ana Sayfaya Dön
          </Link>
          
          <Link
            to="/"
            className="btn-secondary flex items-center justify-center gap-2 w-full"
          >
            <Search className="w-5 h-5" />
            Başlık Ara
          </Link>
        </div>

        <div className="mt-12">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Mavililer Sözlük - İşbirlikçi Sözlük Platformu
          </p>
        </div>
      </motion.div>
    </div>
  )
}